
 <!-- 网点-自建单 -->
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView  :_dataId.sync="dataId" :parent-target="_self"
          @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
<!--      <el-tab-pane label="列表" name="second">-->
<!--        <div>-->
<!--          <vxe-grid show-overflow :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"-->
<!--            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle" :checkbox-config="{-->
<!--              labelField: '',-->
<!--              highlight: true,-->
<!--              reserve: true,-->
<!--              range: true,-->
<!--            }">-->
<!--            <template #form>-->
<!--              <div class="clearfix screen-btns" style="padding-bottom: 6px">-->
<!--                <div class="fl">-->
<!--                  <vxe-button v-if="partsInSave" status="primary" class="button-sty" icon="el-icon-plus"-->
<!--                    @click="openEditDialog">新增-->
<!--                  </vxe-button>-->
<!--                </div>-->
<!--                <div class="fr" style="display: flex">-->
<!--                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px" class="button-sty"-->
<!--                    @click="searchEvent">搜索-->
<!--                  </vxe-button>-->
<!--                </div>-->
<!--              </div>-->
<!--              <el-collapse-transition name="fade">-->
<!--                <vxe-form ref="form" class="screen-box" title-width="6vw" title-align="right" :data="formData"-->
<!--                  @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">-->
<!--                  <vxe-form-item title="用户姓名:" field="projectNo">-->
<!--                    <template v-slot>-->
<!--                      <el-input v-model="requestParam.userName" style="width: 10vw" size="small" clearable />-->
<!--                    </template>-->
<!--                  </vxe-form-item>-->
<!--                  <vxe-form-item title="用户电话:" field="projectName">-->
<!--                    <template v-slot>-->
<!--                      <el-input v-model="requestParam.userMobile" style="width: 10vw" size="small" clearable />-->
<!--                    </template>-->
<!--                  </vxe-form-item>-->
<!--                  <vxe-form-item title="上门时间:" field="name">-->
<!--                    <template v-slot>-->
<!--                      <el-select v-model="requestParam.projectType" clearable style="width: 10vw">-->
<!--                        <el-option v-for="item in projectTypeList" :key="item.id" :value="item.id"-->
<!--                          :label="item.label"></el-option>-->
<!--                      </el-select>-->
<!--                    </template>-->
<!--                  </vxe-form-item>-->
<!--                  <vxe-form-item title="服务类型:" field="name">-->
<!--                    <template v-slot>-->
<!--                      <el-select v-model="requestParam.stat" clearable style="width: 10vw">-->
<!--                        <el-option :value="1" label="制单"></el-option>-->
<!--                        <el-option :value="2" label="待审核"></el-option>-->
<!--                        <el-option :value="5" label="已审核"></el-option>-->
<!--                        <el-option :value="6" label="驳回"></el-option>-->
<!--                        <el-option :value="98" label="关闭"></el-option>-->
<!--                        <el-option :value="99" label="取消"></el-option>-->
<!--                      </el-select>-->
<!--                    </template>-->
<!--                  </vxe-form-item>-->
<!--                </vxe-form>-->
<!--              </el-collapse-transition>-->
<!--            </template>-->
<!--            <template #showAmount="{ row }">-->
<!--              <span v-if="currentSiteLevel == 2">*</span>-->
<!--              <span v-else>{{ row.amount }}</span>-->
<!--            </template>-->

<!--            <template #option="{ row }">-->
<!--              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id)" >-->
<!--                <el-tooltip  effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">-->
<!--                  <i class="el-icon-edit" />-->
<!--                </el-tooltip>-->
<!--              </a>-->

<!--              <el-dropdown @command="handleCommand($event, row)">-->
<!--                <span class="el-dropdown-link">-->
<!--                  <i class="el-icon-arrow-down el-icon&#45;&#45;right" style="color: #2a6494"></i>-->
<!--                </span>-->
<!--                <el-dropdown-menu slot="dropdown">-->
<!--                  <el-dropdown-item command="提交" v-if="-->
<!--                    row.stat == 1-->
<!--                  ">提交</el-dropdown-item>-->
<!--                  <el-dropdown-item command="审核" v-if="row.stat == 2">审核</el-dropdown-item>-->
<!--                </el-dropdown-menu>-->
<!--              </el-dropdown>-->
<!--            </template>-->

<!--            <template #pager>-->
<!--              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>-->
<!--            </template>-->
<!--          </vxe-grid>-->
<!--        </div>-->
<!--      </el-tab-pane>-->
    </el-tabs>

    <!-- <closeDialog v-if="showCloseDialog"  :dataId="currentRow.id" :inNo="currentRow.inNo" :type="type"
      :visiable.sync="showCloseDialog" multi="true" @goBackIndex="goBackIndex" /> -->

  </div>
</template>

<script>
import editView from "./edit.vue";
import { initVxeTable } from "@/const/crud/admin/table";
import pager from "@/components/pager/index.vue";
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
import closeDialog from "@/views/accessories/access/pass/auditOrCloseDialog.vue";
import { indexPageMixins, siteMixins } from "@/mixins/tabChang";

export default {
  name: "buildOrder",

  mixins: [indexPageMixins, siteMixins],
  components: { editView, pager },
  data() {
    return {
      total: 0,

      // partsInSave: false, //新增保存
      // partsInCheck: false, //审核
      // partsInCancel: false, //作废

      // showCloseDialog: false,
      type: null,
      currentRow: null,

      showStat: false,
      showTable: false,
      requestParam: {
        searchCount: false, // 是否分页
        current: 1, // 当前页面
        size: 0, // 页面数据量

        // stat: null,
        // inNo: null,
        // inWarehouseId: null,
        // checkDate: [],
        // createDate: [],
      },

      formData: {
        stat: null,
        inNo: null,
        // inWarehouseId: null,
        // checkDate: [],
        // createDate: [],
      },
      // projectTypeList: [],
      // warehouseList: [],
      // sitePromptList: [],
      // input: "",
      // showPreconditionDialog: false,
      // showPreconditionDialog2: false,
      // labelPage:[],

      // pickerOptions: {
      //   shortcuts: [
      //     {
      //       text: "最近一周",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //     {
      //       text: "最近一个月",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //     {
      //       text: "最近三个月",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //   ],
      // },

      activeName: "first",
      dataId: 0,
      // soProjectDTO:null,

      vxeOption: {},
      pageSizes: [10, 20, 100],
      showEdit: false,
      // columns: [
      //   {
      //     type: "checkbox",
      //     width: 60,
      //     title: "序号",
      //     resizable: false,
      //     fixed: "left",
      //   },
      //   {
      //     width: 100,
      //     field: "stat",
      //     fixed: "right",
      //     title: "操作",
      //     showOverflow: true,
      //     slots: { default: "option" },
      //   },
      //   {
      //     title: "用户姓名",
      //     field: "projectNo",
      //     width: 180,
      //   },
      //   { title: "用户电话", field: "projectName", width: 150 },
      //   { title: "期待上门时间", field: "createTime", width: 150 },
      //   {
      //     title: "指派工程师",
      //     field: "projectTypeName",
      //     width: 120,
      //   },
      //   { title: "地区", field: "areaName", width: 200 },
      //   {
      //     title: "详细地址",field: "address",width: 150,
      //   },
      //   { title: "创建时间", field: "createTime", width: 150 },
      //   { title: "创建人", field: "createBy", width: 80 },
      // ],
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal;
    },
  },
  created() {
    // this.partsInSave = this.permissions["partsInSave"]; //新增保存
    // this.partsInCheck = this.permissions["partsInCheck"]; //审核
    // this.partsInCancel = this.permissions["partsInCancel"]; //作废
    // this.checkButton = this.permissions["checkButton"];
    //console.log(this.checkButton, "this.checkButton");
  },

  mounted() {
    // this.initProjectType();
    // this.getTableData();
    // this.getDot()
  },

  methods: {

    // getDot(){
    //   this.$http.post("/basic/SoProject/getdot")
    //     .then(res=>{
    //       this.soProjectDTO = res.data.data
    //     })
    // },

    // toFilterData() {
    //   // console.log(55,"触发了搜索");
    //   // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
    //   if (this.formData === "") {
    //     return;
    //   } else {
    //     // 请求查询接口，将列表展现出来
    //     this.searchEvent();
    //   }
    // },
    // // 仓库清空
    // warehouseClear() {
    //   this.warehouseList = [];
    //   this.formData.inWarehouseId = null;
    // },
    // flushed() {
    //   this.$refs["table-m1"].commitProxy("reload");
    // },

    // // 初始化搜索时间type
    // initProjectType() {
    //  this.$http.post("/basic/SoProject/getList")
    //    .then(res=>{
    //      this.projectTypeList = res.data.data
    //    })
    // },


    // 获取服务商提示
    // querySiteSearch(queryStr, callback) {
    //   this.$http({
    //     url: api.snUser.getPromptDataUrl,
    //     method: "post",
    //     data: { userName: queryStr },
    //   }).then((res) => {
    //     console.log(res.data.data, "网点提示内容");
    //     let temp = [];
    //     res.data.data.forEach((item) => {
    //       temp.push({ value: item.userName, id: item.id });
    //     });
    //     callback(temp);
    //   });
    // },
    // 加载table数据
    // getTableData() {
    //   let tableOption = {
    //     vue: this,
    //     tableRef: "table-m1",
    //     path:"/basic/SoProject/getListPage",
    //     param: this.requestParam,
    //     method: "post",
    //     columns: this.columns,
    //   };
    //   this.vxeOption = initVxeTable(tableOption);
    //   this.flushed();
    // },


    // 分页功能
    // changeTablePage(page, flag) {
    //   this.requestParam.size = page.pageSize;
    //   this.requestParam.current = page.currentPage;
    //   this.requestParam.searchCount = flag;
    //   this.getTableData();
    // },

    // 搜索
    // searchEvent() {
    //   // this.$objCopy(this.formData, this.requestParam);

    //   // this.$refs.pager.clearStoreTableDataTotal();
    //   this.requestParam.current = 1;
    //   this.requestParam.searchCount = false;
    //   // this.$refs.pager.reset(); // 重置分页器
    //   // this.getTableData();
    //   this.flushed();
    // },

    // 打开考核弹窗
    // handleCommand(command, row) {
    //   this.currentRow = row;
    //   if (command === "提交") {
    //     this.$baseConfirm("确认提交？").then(() => {
    //       this.$http
    //         .get("/basic/SoProject/submitById", {
    //           params: {
    //             id: row.id,
    //           },
    //         })
    //         .then((res) => {
    //           this.$message.success("提交成功！");
    //           this.reload();
    //         })
    //         .catch((e) => {
    //           console.error(e);
    //           this.$message.error("提交失败！");
    //         });
    //     });
    //   } else if (command === "审核") {
    //     this.$baseConfirm("您确定要审核通过吗？").then(() => {
    //       this.$http
    //         .get("/basic/SoProject/examineById", {
    //           params: {
    //             id: row.id,
    //           },
    //           // isLoading: true,
    //         })
    //         .then((res) => {
    //           this.$message.success("审核成功！");
    //           this.reload();
    //         })
    //         .catch((e) => {
    //           console.error(e);
    //           this.$message.error("审核失败！");
    //         });
    //     });
    //   }
    // },

    // addressClickEvent(row, id) {
    //   this.openEditDialog(row.id);
    //   console.log(row, id, "row");
    // },
    // 选中的按钮

    // 新增
    // openEditDialog(id) {
    //   this.dataId = !id || typeof id == "object" ? 0 : id;
    //   this.activeName = "first";
    //   this.$openEditView("showEdit");
    //   console.log("触发了跳转");
    // },
  },
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #2a6494;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;
}
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #fff;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #ebeef5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;
}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
</style>
